import { createAppFromCommonTemplate, lazyImport } from '@helpers'

const { FaqArticle } = lazyImport(
  () => import('@components/FaqArticle/FaqArticle'),
  'FaqArticle',
)

export const renderFaqArticleApp = (
  faqArticleEl: HTMLElement | null,
  faqData: any,
) => {
  createAppFromCommonTemplate(faqArticleEl, <FaqArticle faqData={faqData} />)
}
